import React, { useEffect, useState } from "react";
import "./Signupnew.scss";
import SiginInContainer from "./siginInContainer";
import { useSelector } from "react-redux";


const Signupnew = ({ isOpen, onClose, signInPopupDesktop }: any) => {

 const isMobile = useSelector((state:any)=>state?.navigation?.isMobile)
 const [isViewportMobile, setIsViewportMobile] = useState(
   typeof window !== "undefined" ? window.innerWidth <= 768 : false
 );
 const isMobileView = isMobile || isViewportMobile;

 useEffect(() => {
   const handleResize = () => setIsViewportMobile(window.innerWidth <= 768);
   window.addEventListener("resize", handleResize);
   return () => window.removeEventListener("resize", handleResize);
 }, []);
 
 if (!isOpen) {
   return null;
 }
 
  return (
    <div
      className={"Signup-popup-container"}
      onMouseDown={(event) => {
        event.stopPropagation();
      }}
      onClick={(event) => {
        event.stopPropagation();
        // if (event.target === event.currentTarget) {
        //   onClose();
        // }
      }}
    >
      <div
        className={isMobile ? "Signup-popup" : "Signup-popup-D"}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
       <SiginInContainer  isOpen={isOpen} onClose={onClose} signInPopupDesktop={signInPopupDesktop}/>
      </div>
    </div>
  );
};

export default Signupnew;
